import React from 'react';
import { Box, Collapse, TableCell } from '@material-ui/core';
import { PaxList } from './PaxList'
import {StyledTableRow} from '../util/StyledTableRow'
import _ from 'lodash'


export const PaxInfoResult = (props) => {
  const {row, modalClasses, isMobile, openAccordion, newTexts} = props;

  return (
    <StyledTableRow>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderTop: '1px solid #b9b9b9' }} colSpan={12}>
        <Collapse in={openAccordion} timeout="auto" unmountOnExit>
          <Box margin={1}>
            <PaxList rowPax={row.passengers ? row.passengers : []} flight={row} newTexts={newTexts} modalClasses={modalClasses} isMobile={isMobile} />
          </Box>
        </Collapse>
      </TableCell>
    </StyledTableRow>
  )
}